import { isTelegramMiniApp } from "./telegram";
import { isMaxMiniApp, getMaxWebApp } from "./max";
import { YM_GOAL_CHECKOUT_SUBMIT, ymReachGoal } from "./yandexMetrika";
function resolvePaymentUrl(raw) {
    const trimmed = raw?.trim();
    if (!trimmed)
        return null;
    try {
        return new URL(trimmed, window.location.href).href;
    }
    catch {
        return null;
    }
}
/**
 * Обычный веб (не мини-апп) — оплату открываем в ОТДЕЛЬНОЙ вкладке, чтобы
 * браузерный «назад» не ломал/не закрывал приложение. В мини-аппах TG/MAX
 * оплата уходит во внешний браузер через openLink — вкладку не открываем.
 */
export function isWebPaymentEnv() {
    return !isTelegramMiniApp() && !isMaxMiniApp();
}
/**
 * Ведём пользователя на платёжную страницу.
 *
 * - Мини-апп TG/MAX → openLink (внешний браузер). Если случайно передали
 *   заранее открытую вкладку — закрываем её.
 * - Веб + заранее открытая вкладка (`payWindow` — открыта СИНХРОННО в жесте
 *   клика, чтобы не блокировал попап) → ведём её на оплату; приложение остаётся
 *   в своей вкладке.
 * - Веб без вкладки (попап заблокирован) → фолбэк в той же вкладке, как раньше
 *   (Safari часто игнорирует переход из цепочки Promise — переносим в macrotask).
 *
 * ПРИМЕЧАНИЕ: у `payWindow` намеренно НЕ обнуляем opener — по нему вкладка
 * оплаты (`/payment/success`) понимает, что она попап, и сигналит главной
 * вкладке. Провайдер (ЮKassa/Lava) доверенный, риск reverse-tabnabbing мал.
 */
export function navigateToPaymentPage(paymentUrl, payWindow) {
    const url = resolvePaymentUrl(paymentUrl);
    if (!url) {
        console.error("[navigateToPaymentPage] Invalid or empty payment_url:", paymentUrl);
        payWindow?.close();
        return;
    }
    // Ступень воронки Метрики «ушёл на кассу». Здесь ЕДИНСТВЕННЫЙ choke point:
    // через navigateToPaymentPage идут все покупки (пейвол, /balance, модалка
    // пополнения, релиз) и ровно в момент, когда платёж создан и получен рабочий
    // payment_url. Шлём ДО открытия окна/редиректа — дальше вкладка уходит на
    // сайт провайдера. Best-effort и синхронно, переход не задерживает.
    ymReachGoal(YM_GOAL_CHECKOUT_SUBMIT);
    if (isTelegramMiniApp() && window.Telegram?.WebApp) {
        const webApp = window.Telegram.WebApp;
        if (webApp.openLink) {
            webApp.openLink(url);
            payWindow?.close();
            return;
        }
    }
    // MAX Mini App — открываем платёжную ссылку системным браузером.
    if (isMaxMiniApp()) {
        const maxApp = getMaxWebApp();
        if (maxApp?.openLink) {
            maxApp.openLink(url);
            payWindow?.close();
            return;
        }
    }
    // Веб: заранее открытая вкладка → ведём её на оплату.
    if (payWindow) {
        payWindow.location.replace(url);
        return;
    }
    // Фолбэк: попап заблокирован — переход в той же вкладке (как было).
    // macrotask: Safari часто не применяет переход из цепочки Promise после await.
    setTimeout(() => window.location.replace(url), 0);
}
